module.exports = __webpack_public_path__ + "img/exchange-1.84efb20e.png";